import React from "react"
import CardDataType from "./CardDataType";
import DateHelper from "../../DateHelper/DateHelper";

export default class CardOrCashDataType extends React.Component{
  
  constructor(props) {
    super(props);
  };

  render() {
    if (this.props.row.cash_drawer) {
      return (
        <div className={this.renderAlignment()}>
          <strong>{I18n.t('cash_drawer')}:</strong> {this.props.row.cash_drawer.code} - {this.props.row.cash_drawer.name}
          <br />
          <strong>{I18n.t('user')}:</strong> {`${this.props.row.cash_drawer_log.user.first_name} ${this.props.row.cash_drawer_log.user.last_name}`}
        </div>
      );
    } else if(this.props.row.voucher){
      return(
        <div className={this.renderAlignment()}>
          <strong>{I18n.t('voucher')}:</strong> {this.props.row.voucher.redemption_code}
          <br />
          {
            this.props.row.voucher.exp_date ?
              <span><strong>{I18n.t('exp_date')}:</strong> {DateHelper.printDateToScreen(this.props.row.voucher.exp_date, this.props.date_format)}</span>
            :
            ''
          }
        </div>
      );
    } else if (this.props.row.payment_type && this.props.row.payment_type.name == "rentals_united") {
      return (<div className={this.renderAlignment()}>
        <strong>{I18n.t('channel_payment')}</strong> {this.props.row.ota_channel ? this.props.row.ota_channel : null }
      </div>)
    }else if (this.props.row.payment_type && this.props.row.payment_type.name == "system_import") {
      return (<div className={this.renderAlignment()}>
        <strong>{I18n.t('system_import')}</strong>
      </div>)
    }else {
      return (
        <div className={this.renderAlignment()} >
          <CardDataType data={this.props.data ? this.props.data : this.props.row} />
        </div>
      );
    };
  };

  renderAlignment() {
    if (this.props.header && this.props.header.text_align === "left") {
      return "text-left";
    } else if (this.props.header && this.props.header.text_align === "center") {
      return "text-center";
    } else if (this.props.header && this.props.header.text_align === "right") {
      return "text-right";
    } else {
      ("");
    };
  };

};